import { createFileRoute } from "@tanstack/react-router";

import { AgentThreadPage } from "@/features/chat/components/AgentThreadPage";

export const Route = createFileRoute("/_authenticated/agent/$threadId")({
  component: AgentThreadRoute,
});

function AgentThreadRoute() {
  const { threadId } = Route.useParams();
  return <AgentThreadPage threadId={threadId} />;
}
